export default function SessionControls({ voiceGender, setVoiceGender, includeAudio, setIncludeAudio }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <label className="text-sm text-gray-600">Voice</label>
        <select
          value={voiceGender}
          onChange={(e) => setVoiceGender(e.target.value)}
          className="border rounded-md text-sm px-2 py-1"
        >
          <option value="female">Female</option>
          <option value="male">Male</option>
        </select>
        <label className="text-sm text-gray-600 ml-3">Include audio</label>
        <input
          type="checkbox"
          className="ml-1"
          checked={includeAudio}
          onChange={(e) => setIncludeAudio(e.target.checked)}
        />
      </div>
    </div>
  );
}